import { Palette } from '../constants/palette';
const sizes = {
    s: '32px',
    m: '48px',
    l: '64px',
};
const selectorColors = {
    hoverColor: Palette.white,
    disabledColor: Palette.gray50,
    focusBorderColor: Palette.royalBlue,
    focusMiddleBorder: Palette.royalBlue,
    focusInnerBorder: Palette.white,
};
export const button = {
    borderRadius: '16px',
    borderRadii: {
        s: '8px',
        m: '12px',
        l: '16px',
    },
    selectorColors,
    sizes,
    variants: {
        primary: {
            color: 'secondary',
            backgroundColor: 'cta',
            borderColor: 'cta',
        },
        secondary: {
            color: 'cta',
            backgroundColor: 'secondary',
            borderColor: 'cta',
        },
        secondaryGray: {
            color: 'text',
            backgroundColor: 'secondaryGray',
            borderColor: 'transparent',
            '&:hover, &:focus, &:focus:not(:focus-visible)': {
                backgroundColor: 'gray90',
                borderColor: 'transparent',
            },
        },
        transparent: {
            color: 'cta',
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            'button&:hover': {
                backgroundColor: 'transparent',
                borderColor: 'transparent',
                color: `hover`,
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RoZW1lL2J1dHRvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFHL0MsTUFBTSxLQUFLLEdBQUc7SUFDWixDQUFDLEVBQUUsTUFBTTtJQUNULENBQUMsRUFBRSxNQUFNO0lBQ1QsQ0FBQyxFQUFFLE1BQU07Q0FDVixDQUFDO0FBRUYsTUFBTSxjQUFjLEdBQUc7SUFDckIsVUFBVSxFQUFFLE9BQU8sQ0FBQyxLQUFLO0lBQ3pCLGFBQWEsRUFBRSxPQUFPLENBQUMsTUFBTTtJQUM3QixnQkFBZ0IsRUFBRSxPQUFPLENBQUMsU0FBUztJQUNuQyxpQkFBaUIsRUFBRSxPQUFPLENBQUMsU0FBUztJQUNwQyxnQkFBZ0IsRUFBRSxPQUFPLENBQUMsS0FBSztDQUNoQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFvQjtJQUNyQyxZQUFZLEVBQUUsTUFBTTtJQUNwQixXQUFXLEVBQUU7UUFDWCxDQUFDLEVBQUUsS0FBSztRQUNSLENBQUMsRUFBRSxNQUFNO1FBQ1QsQ0FBQyxFQUFFLE1BQU07S0FDVjtJQUNELGNBQWM7SUFDZCxLQUFLO0lBQ0wsUUFBUSxFQUFFO1FBQ1IsT0FBTyxFQUFFO1lBQ1AsS0FBSyxFQUFFLFdBQVc7WUFDbEIsZUFBZSxFQUFFLEtBQUs7WUFDdEIsV0FBVyxFQUFFLEtBQUs7U0FDbkI7UUFDRCxTQUFTLEVBQUU7WUFDVCxLQUFLLEVBQUUsS0FBSztZQUNaLGVBQWUsRUFBRSxXQUFXO1lBQzVCLFdBQVcsRUFBRSxLQUFLO1NBQ25CO1FBQ0QsYUFBYSxFQUFFO1lBQ2IsS0FBSyxFQUFFLE1BQU07WUFDYixlQUFlLEVBQUUsZUFBZTtZQUNoQyxXQUFXLEVBQUUsYUFBYTtZQUMxQiwrQ0FBK0MsRUFBRTtnQkFDL0MsZUFBZSxFQUFFLFFBQVE7Z0JBQ3pCLFdBQVcsRUFBRSxhQUFhO2FBQzNCO1NBQ0Y7UUFDRCxXQUFXLEVBQUU7WUFDWCxLQUFLLEVBQUUsS0FBSztZQUNaLGVBQWUsRUFBRSxhQUFhO1lBQzlCLFdBQVcsRUFBRSxhQUFhO1lBQzFCLGVBQWUsRUFBRTtnQkFDZixlQUFlLEVBQUUsYUFBYTtnQkFDOUIsV0FBVyxFQUFFLGFBQWE7Z0JBQzFCLEtBQUssRUFBRSxPQUFPO2FBQ2Y7U0FDRjtLQUNGO0NBQ0YsQ0FBQyJ9